<template>
  <b-row
    class="pb-2 border-bottom border-violeta-claro border-2 mb-0 mb-lg-2 mt-0 mt-lg-3 mx-0"
  >
    <b-col lg col="" class="px-0 mt-0 mt-lg-0">
      <div
        class="h4 text-morado-claro font-weight-bold text-center text-lg-left gilmer mb-0"
      >
        {{ nombre }}
      </div>
    </b-col>
    <b-col
      v-if="modoShinnyVacantes"
      lg
      class="row justify-content-end px-0 mx-0 mt-2 mt-lg-0 col-auto"
    >
      <b-col lg="auto" class="pl-2 pr-0">
        <!-- <b-col cols="6" lg="auto" class="pl-0 pr-1"> -->
        <!--<router-link to="/" class="btn btn-azul-outline px-3 px-lg-5 w-100">-->
        <router-link
          to="/"
          class="text-morado-claro gilmer font-weight-light mb-0"
        >
          <FontAwesomeIcon icon="arrow-left" class="mr-0 mr-md-2" />
          <span
            class="d-none d-md-inline-block ml-2 btn btn-yellow border-violeta-claro btn-secondary"
            >VER MÁS ESTABLECIMIENTOS
          </span>
        </router-link>
      </b-col>
    </b-col>
  </b-row>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faArrowLeft, faPrint } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faArrowLeft, faPrint);
export default {
  props: {
    nombre: {
      type: String,
      required: true
    }
  },
  components: {
    FontAwesomeIcon
  },
  computed: {
    modoShinnyVacantes() {
      return MODO_SHINNY_VACANTES ? false : true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ficha/Encabezado.vue